<template>
  <v-container fluid>
    <material-card icon="mdi-clipboard-text" inline title="Day Glance">
      <v-card flat class="px-2"> </v-card>
      <v-card-actions>
        <div class="d-flex justify-center"></div>
        <a @click="$router.back()">
          <v-btn
            v-if="$vuetify.breakpoint.smAndUp"
            elevation="1"
            absolute
            right
            top
          >
            <v-icon left>mdi-arrow-left</v-icon>back
          </v-btn>
          <v-btn
            v-else
            fixed
            right
            fab
            small
            color="grey lighten-2"
            elevation="1"
            class="mr-n2 mt-10"
            style="opacity: 0.6"
          >
            <v-icon>mdi-arrow-left</v-icon>
          </v-btn>
        </a>
      </v-card-actions>
      <v-container fluid>
        <v-card class="mx-auto" max-width="80%">
          <v-card-item>
            <div>
              <div class="text--primary" align="center">
                {{ this.week.folderName.name || '' }} {{ this.day.dayName
                }}<br />
              </div>
              <div class="text-h4 text--primary" align="center">
                <label>Theme Time ({{ themeTime }} Min) : </label>
                {{ themeName }}
              </div>
              <v-divider></v-divider>
            </div>
          </v-card-item>
          <v-row>
            <v-col md="6" sm="12">
              <v-textarea
                counter
                label="Goal"
                required
                rows="2"
                v-model.trim="goal"
              ></v-textarea>
            </v-col>
            <v-col md="6" sm="12">
              <label>Intelli-Skills : </label>
              <v-autocomplete
                :readonly="true"
                placeholder="Enter Skill Name"
                class="my-0 py-1"
                v-model="skills"
                item-value="name"
                :items="skills"
                key="id"
                item-text="name"
                multiple
                chips
              >
              </v-autocomplete>
            </v-col>
          </v-row>
        </v-card>
      </v-container>
      <v-container fluid>
        <v-card class="mx-auto" max-width="80%" align="left">
          <v-card-text>
            <v-row>
              <v-col cols="12" md="6">
                <v-textarea
                  readonly
                  label="Development Area"
                  required
                  rows="2"
                  v-model.trim="developmentArea"
                ></v-textarea>
              </v-col>
              <v-col cols="12" md="6">
                <v-textarea
                  readonly
                  counter
                  label="Outcome"
                  required
                  rows="2"
                  v-model.trim="outcome"
                ></v-textarea>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="6">
                <v-textarea
                  readonly
                  counter
                  label="Resources from WOW KIT"
                  required
                  rows="2"
                  v-model.trim="resourcesFromWowKit"
                ></v-textarea>
              </v-col>
              <v-col cols="12" md="6">
                <v-textarea
                  readonly
                  counter
                  label="Others"
                  required
                  rows="2"
                  v-model.trim="others"
                ></v-textarea>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="12">
                <v-textarea
                  readonly
                  counter
                  label="Preparation"
                  required
                  rows="2"
                  v-model.trim="preparation"
                ></v-textarea>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-container>
      <v-container fluid>
        <v-card class="mx-auto" max-width="80%">
          <material-card inline :title="preperationTitle">
            <v-card-text>
              <div v-for="(proc, index) in procedure" :key="index">
                <v-Chips class="font-weight-medium body-2"
                  >{{ proc.step }} ({{ proc.time }} Mins)</v-Chips
                >
                <v-row v-for="step in proc.steps" :key="step.id">
                  <v-col cols="12" md="4">
                    <span
                      ><img
                        src="https://cdn.fcglcdn.com/brainbees/images/n/fc_logo.jpg"
                    /></span>
                  </v-col>
                  <v-col cols="12" md="8">
                    <ckeditor
                      :readOnly="true"
                      :setReadOnly="true"
                      v-model="step.steps"
                      ref="ckeditorRef"
                    ></ckeditor>
                  </v-col>
                </v-row>
              </div>
            </v-card-text>
          </material-card>
        </v-card>
      </v-container>
    </material-card>
  </v-container>
</template>

<script>
import CONSTANTS from '@/utils/constants'
import MaterialCard from '@/components/template/MaterialCard'

export default {
  components: { MaterialCard },
  props: ['dayId'],
  data () {
    return {
      dayList: [],
      dayDetails: [],
      skills: [],
      preperationTitle: 'Preperation',
      goal: '',
      developmentArea: '',
      outcome: '',
      name: '',
      procedurePosition: 0,
      resourcesFromWowKit: '',
      others: '',
      preparation: '',
      procedures: [],
      themeName: '',
      week: {
        folderName: {
          name: ''
        }
      },
      day: {
        dayName: ''
      }
    }
  },
  created: async function () {
    await this.getDayScheduleList()
  },
  watch: {},
  methods: {
    getDayScheduleList: async function () {
      try {
        let res = await http.get(
          `${CONSTANTS.API_URL}/api/curriculum_cms/get-dayatglance/${this.dayId}`
        )
        this.dayList = res.data.dayDetailsByID
        if (this.dayList) {
          this.title = `${this.dayList.title} (${this.dayList.themeTime} Minutes)`
          this.themeName = this.dayList.theme
          this.themeTime = this.dayList.themeTime
          if (this.dayList.dayDetails.length) {
            this.isEdit = true
            let dayDetails = this.dayList.dayDetails[0]
            this.goal = dayDetails.goal
            this.outcome = dayDetails.outcome
            this.preparation = dayDetails.preparation
            this.others = dayDetails.others
            this.resourcesFromWowKit = dayDetails.resourcesFromWowKit
            this.developmentArea = dayDetails.developmentArea
            if (this.dayList.Procedure.length) {
              this.procedure = []
              let positionArray = this.dayList.Procedure.map(
                (obj) => obj.position
              )
              positionArray = positionArray.map((obj) => Number(obj))
              let maxPosition = Math.max(...positionArray)
              let positionDifference = 0
              if (maxPosition !== this.dayList.Procedure.length) {
                positionDifference =
                  Number(maxPosition) - Number(this.dayList.Procedure.length)
              }
              for (let proc of this.dayList.Procedure) {
                this.procedure.push({
                  id: proc.id,
                  step: proc.step,
                  time: proc.time,
                  position: Number(proc.position) - Number(positionDifference),
                  files: null,
                  isDownloadableValue: false,
                  steps: proc.ProcedureSteps.length
                    ? proc.ProcedureSteps.map((obj) => {
                      return {
                        id: obj.id,
                        steps: obj.steps,
                        position: obj.position
                      }
                    })
                    : []
                })
              }
            }
            this.skills = this.dayList.Skills.map((obj) => {
              return {
                id: obj.id,
                skills: obj.skills,
                name: obj.skills,
                deletedAt: obj.deletedAt,
                isHighlighted: obj.isHighlighted
              }
            })
          }
          console.log('this.skills', this.skills)
        }
        this.day = res.data.day
        this.week = res.data.week
      } catch (e) {
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        this.errMsg(errorMessage)
      }
    },

    okMsg (msg) {
      return this.$dialog.info({
        text: msg,
        title: 'Success'
      })
    },
    errMsg (msg) {
      return this.$dialog.error({
        text: msg,
        title: 'Error'
      })
    }
  }
}
</script>
<style></style>
